import axios from "axios";

// const BASE_URL = process.env.PUBLIC_URL;

function authHeader() {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem("user"));

  if (user) {
    return { Authorization: "Bearer " + user };
  } else {
    return {};
  }
}

export const authenticateUser = payload =>
  axios({
    method: "post",
    url: "/openempi-downloads/api/users/login",
    headers: {
      Accept: "application/json"
    },
    data: payload
  })
    .then(response => {
      localStorage.setItem("user", JSON.stringify(response.data));
      return { response: response.data };
    })
    .catch(error => {
      console.log(error);
      return { error };
    });

export const changePassword = payload =>
  axios({
    method: "put",
    url: "/openempi-downloads/api/users/login",
    headers: {
      Accept: "application/json"
    },
    data: payload
  })
    .then(response => {
      return { response };
    })
    .catch(error => {
      console.log(error);
      return { error };
    });

export const registerUser = payload =>
  axios({
    method: "post",
    url: "/openempi-downloads/api/users",
    headers: {
      Accept: "application/json"
    },
    data: payload
  })
    .then(response => {
      return { response };
    })
    .catch(error => {
      console.log(error);
      return { error };
    });

export const resetPassword = payload =>
  axios({
    method: "put",
    url: "/openempi-downloads/api/users",
    headers: {
      Accept: "application/json"
    },
    data: payload
  })
    .then(response => {
      return { response };
    })
    .catch(error => {
      console.log(error);
      return { error };
    });

export const getAllDownloads = () =>
  axios({
    method: "get",
    url: "/openempi-downloads/api/downloads",
    headers: {
      ...authHeader(),
      Accept: "application/json"
    }
  })
    .then(response => ({ response }))
    .catch(error => ({ error }));
